import { ProductAutomationLogDocument, RequestStatus } from '@mailingr/data-models';

export const AUTOMATION_LOGS_REDUCER_NAME = 'automationLogs';
export interface AutomationLogsReducer {
  clientAutomationLogs: ProductAutomationLogDocument[];
  clientAutomationLogsStatus: RequestStatus | null;
  selectedClient: null | { email: string; productId: string | null };
}
